import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';

import { ResultResponse } from '../interfaces';
import { TbaEvaluationMethod, ListTbaEvaluationMethodsResponse } from '../models';

@Injectable()
export class TbaEvaluationMethodsService extends BaseService<TbaEvaluationMethod> {
  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public list(queryString?: string): Observable<ResultResponse<ListTbaEvaluationMethodsResponse>> {
    return super.list(queryString);
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}tba-evaluation-methods/`;
  }
}
